import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

@Module({ namespaced: true })
class App extends VuexModule {

    public isMobile = window.innerWidth < 1025;

    public windowWidth = window.innerWidth;

    public loading = false;

    @Mutation
    public sizeChanged(): void {
        this.isMobile = window.innerWidth < 1025;
        this.windowWidth = window.innerWidth;
    }

    @Mutation
    public setLoading(loading: boolean): void {
        this.loading = loading;
    }

    @Action({ rawError: true })
    public onResize(): void {
        this.context.commit('sizeChanged');
    }

    @Action({ rawError: true })
    public startLoading(): void {
        this.context.commit('setLoading', true);
    }

    @Action({ rawError: true })
    public stopLoading(): void {
        this.context.commit('setLoading', false);
    }

}


export default App;
